import React, { useState } from "react";
import Notiflix from "notiflix";

import {
  Row,
  Form,
  Col,
  Divider,
  Spin,
  Table,
  Typography,
  Select,
  Button,
  Modal,
  Tooltip,
} from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { BOM } from "../../../../../services/definedMethod";
import styles from "../../../../../assets/styles/styles";

const ConfigureFundSource = (props) => {
  //DECLARED VARIABLES
  const {
    onFinish,
    form,
    userData,
    isLoading,
    setIsLoading,
    configureFundTableSource,
    setConfigureFundTableSource,
    paymentTypeOptions,
    assetAccountOptions,
    fundCount,
    setFundCount,
  } = props;
  const { session } = userData;
  const { Title } = Typography;

  // DECLARED VARIABLES FOR FORM
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleFundSourceDelete = (key) => {
    let action = "Delete  ";
    let label = BOM.SubstringFormat(key.fundSourceAccountValue, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = configureFundTableSource.filter(
          (item) => item.id !== key.id
        );
        setConfigureFundTableSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  const columns = [
    {
      title: "Payment Type",
      dataIndex: "paymentTypeValue",
    },
    {
      title: "Fund Source",
      dataIndex: "fundSourceAccountValue",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        configureFundTableSource.length >= 1 ? (
          <Tooltip title={`Remove`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handleFundSourceDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];

  return (
    <>
      <Divider orientation="left" orientationMargin="0">
        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
          Configure Fund Sources for Payment Channels
        </Title>
      </Divider>
      <FundSourceModal
        isModalOpen={isModalOpen}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        setIsModalOpen={setIsModalOpen}
        paymentTypeOptions={paymentTypeOptions}
        assetAccountOptions={assetAccountOptions}
        setConfigureFundTableSource={setConfigureFundTableSource}
        configureFundTableSource={configureFundTableSource}
        session={session}
        fundCount={fundCount}
        setFundCount={setFundCount}
      />

      {configureFundTableSource?.length > 0 && (
        <>
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {configureFundTableSource.length > 1
                ? "Selected Fund Sources"
                : "Selected Fund Source"}
            </Title>
          </Divider>
         <Col span={24}>
         <Table
            columns={columns}
            dataSource={configureFundTableSource}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: "10",
            }}
          />
         </Col>
        </>
      )}
    </>
  );
};
export default ConfigureFundSource;

const FundSourceModal = (props) => {
  const {
    session,
    isLoading,
    setIsLoading,
    setConfigureFundTableSource,
    configureFundTableSource,
    isModalOpen,
    setIsModalOpen,
    paymentTypeOptions,
    assetAccountOptions,
    fundCount,
    setFundCount,
  } = props;

  const [useForm] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleFundSourceSave = (formValues) => {
    const newCharges = {
      key: fundCount,
      id: fundCount,
      fundSourceAccountId: formValues.fundSourceAccountId,
      paymentTypeId: formValues.paymentTypeId,
      paymentTypeValue: paymentTypeOptions.find(
        (item) => item.value === formValues.paymentTypeId
      ).label,
      fundSourceAccountValue: assetAccountOptions.find(
        (item) => item.value === formValues.fundSourceAccountId
      ).label,
    };
    setFundCount(fundCount + 1);
    setConfigureFundTableSource([...configureFundTableSource, newCharges]);

    useForm.resetFields();
  };

  return (
    <Row>
      <Button
        type="primary"
        onClick={showModal}
        icon={<PlusOutlined />}
        style={{
          boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
          backgroundColor: "#92428B",
          marginBottom: 20,
        }}
        shape="round"
      >
        {"Add Fund Source"}
      </Button>

      <Modal
        title="Fund Source Information Setup"
        open={isModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleFundSourceSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"paymentTypeId"}
                label={"Payment Type"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld("Payment Type"),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    "Payment Type",
                    "select"
                  )}
                  options={paymentTypeOptions}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"fundSourceAccountId"}
                label={"Fund Source"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld("Fund Source"),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    "Fund Source",
                    "select"
                  )}
                  options={assetAccountOptions}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};
